module.exports = __webpack_public_path__ + "img/offers-active.22237cae.svg";